import { render, staticRenderFns } from "./ChartSection.vue?vue&type=template&id=bc037240&"
import script from "./ChartSection.vue?vue&type=script&lang=js&"
export * from "./ChartSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports